




















import Vue from 'vue';
import store, { KanriInvoiceStore } from "../services/KanriInvoiceStore";
import eventBus from '@/services/eventBus';
import configuration from '@/models/Configuration';
import { t } from "@/plugins/i18n";

interface Data {
  store: KanriInvoiceStore;
  inProgress: boolean;
  errorList: string[];
  objectid: number;
}

export default Vue.extend<Data, {}, {}, {}>({
  data() {
    return {
      store,
      inProgress: true,
      errorList: [],
      objectid: 0,
    }
  },

  async beforeMount() {
    const objectid = Number(this.$route.params.objectId);

    this.objectid = objectid;

    if (!objectid || objectid < 1) {
      eventBus.$emit("error", t("Kanri_KanriSzamlaNemTalalhato", [objectid]));
      return;
    }

    const payload = {
      isEinvoice: false,
      shipDate: new Date().toDateString(),
      remark: "",
    };
    await this.store.refreshInvoice(objectid, "SALE");

    const ret = (await this.store.importKanri(Number(objectid), payload));
    console.log(ret);
    if (!ret) {
      this.$router.push(`/kanri-invoices/sale`);
      return;
    }

    this.errorList = [...ret.errorList];
    this.inProgress = false;

    if (ret && ret.id > 1 && ret.errorList.length == 0) {
      if (!ret.alreadyImported) {
        eventBus.$emit("success", t("Kanri_SikeresSzamlaBeemeles"));
      }

      //TOYT100: pl. hiányzó Kanri fizetési tétel miatti alapértelmezett fizetési mód jelzése
      if (ret.warningList?.length) {
        eventBus.$emit("warn", ret.warningList.join("\n"));
      }
      
      if (ret.retType == "geno") {
        this.$router.push(`/geno-experimental-invoices/${ret.id}`);
      }
      else if(ret .retType == "noto") {
        this.$router.push(`/noto/${ret.id}`);
      }
      else if(ret.retType == "geni") {
        if (configuration.invoiceFlow.enabled) {
          this.$router.push(`/general-incoming-invoice/flow/edit/${ret.id}/3`);
        }
        else {
          this.$router.push(`/general-incoming-invoice/edit/${ret.partnerId}/${ret.id}`);
        }
      }
    }
  },
})
